import AppLayout from "../layouts/Layout";
import {Container, List, ListItem, Typography} from "@mui/material";
import {useEffect, useState } from "react";
import {BlocklistItem} from "../types/types";
import {getDefaultPageable, Page} from "../types/page";
import {indexBlackList} from "../api/controllers/web-controller";




const BlackListDomainPage = () => {

    const [blacklistPage, setBlacklistPage] = useState<Page<BlocklistItem>>();
    const [pageable, setPageable] = useState(getDefaultPageable())


    useEffect(() => {
        indexBlackList(pageable)
            .then(response => {
                setBlacklistPage(response.data)
            })
            .catch(error => {
                alert("Произошла ошибка. Попробуйте позже.");
            })
    }, []);

    return (<AppLayout>
        <Container>
            <h1>Заблокированные домена ({blacklistPage?.totalElements})</h1>
            <Typography>Домены заблокированы для обработки либо по содержанию, либо по указанию РКН</Typography>
            <List>
                {
                    blacklistPage && blacklistPage.content.map(blacklistItem => {

                        return (<ListItem>{blacklistItem.createdAt}| {blacklistItem.domain}</ListItem>)

                    })
                }
            </List>
        {/*  TODO Добавить пагинацию  */}
        </Container>
    </AppLayout>);
}

export default BlackListDomainPage;